import {
  IGeometryModel,
  MarkerModelBase,
} from '@types-custom/models/business/marker.model';
import { AbstractPmvDataSource } from '@types-custom/models/ui/modal-pmv-model';

export interface IPmvModel {
  address: string;
  description: string;
  gatewat: string,
  icon: unknown;
  id: string;
  ip: string;
  markerPopupText: string;
  name: string;
  panelType: string;
  port: number;
  protocol: string;
  stateId: number;
  stateName: string;
  title: string;
  password: string,
  serial: string;
  dataSource: AbstractPmvDataSource,
}

export class PmvModel extends MarkerModelBase {
  static className = 'PmvModel';
  classProperties: IPmvModel;

  constructor(props: IPmvModel, geometry: IGeometryModel) {
    super(geometry, PmvModel.className);
    this.classProperties = props;
  }
}
